// extracted by mini-css-extract-plugin
export default {"wrapper":"DetailPopupButtons_wrapper__xcf9R"};